(function ($) {
  $(function () {
    if (!$.fn.flickity) return;

    var mobile = window.matchMedia('(max-width: 600px)');
    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    $('.main__image-wrapper').each(function () {
      var $wrapper = $(this);

      if ($wrapper.data('imageMarqueeReady')) return;
      $wrapper.data('imageMarqueeReady', true);

      var $track = null;
      var flkty = null;
      var originals = [];
      var frameId = null;
      var lastTime = null;
      var hovered = false;
      var touching = false;
      var focused = false;
      var speed = 35; // Pixels per second.

      function animate(time) {
        if (!flkty || !$wrapper[0].isConnected) return;

        var elapsed = lastTime === null
          ? 0
          : Math.min(time - lastTime, 50);

        lastTime = time;

        if (
          !hovered &&
          !touching &&
          !focused &&
          !document.hidden &&
          !reducedMotion.matches &&
          !flkty.isAnimating &&
          flkty.slideableWidth > flkty.size.innerWidth
        ) {
          flkty.x -= speed * elapsed / 1000;
          flkty.x %= flkty.slideableWidth;
          flkty.positionSlider();
        }

        frameId = requestAnimationFrame(animate);
      }

      function enableSlider() {
        if ($track) return;

        var $images = $wrapper.children(
          '.image_block:not(.floating_image-enable):not(.heading__block)'
        );

        if ($images.length < 2) return;

        $track = $('<div class="mobile-image-marquee"></div>');
        $track.insertBefore($images.first());

        // Save each image's exact original position.
        originals = [];

        $images.each(function () {
          var marker = document.createComment('image-original-position');

          this.parentNode.insertBefore(marker, this);
          originals.push({ element: this, marker: marker });

          $track.append(this);
        });

        $track.flickity({
          cellSelector: '.image_block',
          cellAlign: 'left',
          wrapAround: true,
          freeScroll: true,
          prevNextButtons: false,
          pageDots: false,
          autoPlay: false,
          draggable: false,
          accessibility: false,
          setGallerySize: true
        });

        flkty = $track.data('flickity');
        lastTime = null;
        hovered = false;
        touching = false;
        focused = false;

        $track
          .on('mouseenter.imageMarquee', function () {
            hovered = true;
          })
          .on('mouseleave.imageMarquee', function () {
            hovered = false;
          })
          .on('touchstart.imageMarquee', function () {
            touching = true;
          })
          .on('touchend.imageMarquee touchcancel.imageMarquee', function () {
            touching = false;
          })
          .on('focusin.imageMarquee', function () {
            focused = true;
          })
          .on('focusout.imageMarquee', function (event) {
            focused = this.contains(event.relatedTarget);
          });

        $track.find('img').each(function () {
          if (!this.complete) {
            $(this).one(
              'load.imageMarquee error.imageMarquee',
              function () {
                if (flkty && flkty.isActive) flkty.resize();
              }
            );
          }
        });

        frameId = requestAnimationFrame(animate);
      }

      function disableSlider() {
        if (!$track) return;

        cancelAnimationFrame(frameId);

        $track.off('.imageMarquee');
        $track.find('img').off('.imageMarquee');
        $track.flickity('destroy');

        flkty = null;

        // Restore images without changing headings or floating images.
        originals.forEach(function (item) {
          item.marker.parentNode.replaceChild(item.element, item.marker);
        });

        $track.remove();
        $track = null;
        originals = [];
        lastTime = null;
      }

      function updateSlider() {
        if (mobile.matches) {
          enableSlider();
        } else {
          disableSlider();
        }
      }

      mobile.addEventListener('change', updateSlider);
      updateSlider();
    });
  });
})(jQuery);